import * as React from "react";
const Green = (props) => (
  <svg
    width="78"
    height="78"
    viewBox="0 0 76 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="76" height="76" rx="38" fill="#A2F07B" />
    <path
      d="M44.4989 33.117L36.442 41.3241L33.5011 38.2972C33.3479 38.1723 33.1028 38.1723 32.9803 38.2972L32.0919 39.2021C31.9694 39.327 31.9694 39.5766 32.0919 39.7326L36.1969 43.883C36.3501 44.039 36.5646 44.039 36.7177 43.883L45.9081 34.5213C46.0306 34.3965 46.0306 34.1468 45.9081 33.9908L45.0197 33.117C44.8972 32.961 44.6521 32.961 44.4989 33.117Z"
      fill="#444444"
    />
  </svg>
);
export default Green;
